define('home/templates/moderatedForumsModuleItem',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"recommended-wrap\">\n<div data-role=\"recommended-object\">\n<div class=\"recommended__item\">\n"
    + ((stack1 = container.invokePartial(partials.forumAvatarLink,depth0,{"name":"forumAvatarLink","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<h3 class=\"recommended__name truncate-line spacing-top-narrow\">\n<a href=\"/home/forums/"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</a>\n</h3>\n<a href=\"https://"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + ".disqus.com/admin/\" class=\"button button-outline button-small pull-right\">"
    + alias2(helpers.gettext.call(depth0 != null ? depth0 : {},"Manage",{"name":"gettext","hash":{},"data":data}))
    + "</a>\n</div>\n</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
